import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCardSmall = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "-8 -8 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "path-1-inside-1",
			fill: "white",
			children: /* @__PURE__ */ _jsx("rect", {
				y: 3,
				width: 24,
				height: 18,
				rx: 2
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 3,
			width: 24,
			height: 18,
			rx: 2,
			stroke: "currentColor",
			strokeWidth: 6,
			strokeMiterlimit: 10,
			strokeLinecap: "square",
			strokeLinejoin: "round",
			mask: "url(#path-1-inside-1)"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 4,
			y1: 9.5,
			x2: 20,
			y2: 9.5,
			stroke: "currentColor",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 5,
			y1: 14.5,
			x2: 14,
			y2: 14.5,
			stroke: "currentColor",
			strokeWidth: 3
		})
	]
});
const ForwardRef = forwardRef(SvgCardSmall);
export default ForwardRef;
